import { MaptycsApplication } from '../account/maptycs-application';

export class AccountMemberPermission {

    public static READ = 0;
    public static WRITE = 1;

}
